import { useTranslation } from 'react-i18next'

const CashierEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="cashier-end-title"
      {...props}
    >
      <title id="cashier-end-title">{t('antagonists:cashier:components:end')}</title>
      <defs>
        <clipPath id="cashier-end-b">
          <path
            d="M1537.06 391.56c-7.1 4.21-15.87 20.99-15.87 20.99s-36.26 11.35-61.29 24.08c-16.28 8.29-35.21 19.12-41.53 28.98-18.41 28.73 40.8 206.02 43.61 256.88 2.81 50.87-5.81 223.49-5.81 223.49s43.75 23.61 116.44 8.31c80.43-16.94 100.58-4.63 128.67-16.09 28.09-11.45 74.4-28.14 74.4-28.14s-36.79-153.67-38.19-207.08c-1.4-53.41 1.42-189.31 7.03-210.93 5.61-21.63 3.14-48.7-26.33-63.97-29.49-15.25-75.62-25.16-75.62-25.16s-6.02-11.95-10.19-15.2c-8.86-6.89-73.97-8.77-95.29 3.85h-.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="cashier-end-c">
          <path
            d="m1487.77 541.87 2.7 38.1 83.57-9.3-4.03-36.22c-1.12-.11-82.24 7.4-82.24 7.4v.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:none}.e{fill:#0077be}.f{fill:#f1f1f3}.g{fill:#e7474c}.h{fill:#940c3b}.i{fill:#93a090}.j{fill:#9e6c30}.k{fill:#cda67b}.l{fill:#ca332e}.m{fill:#1c3628}.n{fill:#4a9055}.o{clip-path:url(#cashier-end-c)}.p{clip-path:url(#cashier-end-b)}'
          }
        </style>
      </defs>
      <path
        d="M1604.92 198.57s-36.2-27.68-70.54-3.64c-26.37 18.45-6.39 37.34-6.39 37.34s-23.19 8.52-24.75 26.63c-1.56 18.11.73 22.37-6.21 26.49-7.12 4.24-10.44 3.53-10.44 3.53s1.47 15.68 12.09 18.7c10.62 3.02 17.92-.21 17.92-.21s-18.73 34.98-10 51.53c8.74 16.55 20.05 19.09 20.05 19.09s-1.31-8.08 7.17-12.96 25.78-23.4 44.26-14.1c18.48 9.32 42.95 27.7 53.87 30.27 15.62 3.69 19.5-5.26 19.5-5.26s-8.75-2.47-10.12-13.94c-1.14-9.61 6.5-15.16 14.24-19.41 7.74-4.24 11.35-5.74 17.19-16.44 5.84-10.72 1.14-20.26 1.14-20.26s12.13-.73 17.51-9.25c9.5-15.04 3.3-26.03 3.3-26.03s-10.96 9.07-20.24-1.21c-9.29-10.28-4.72-33.34-9.94-49.93-5.24-16.58-22.35-21.25-35.19-23.05-13.51-1.86-24.4 2.1-24.4 2.1Z"
        style={{
          fill: '#93a090',
        }}
      />
      <path
        d="M1751.94 821.82s-6.85 193.85-14.74 252.25c-7.9 58.4-21.86 93.62-22.19 115.2-.36 21.59-12.64 124.54-15.71 154.29-3.07 29.76 5.56 159.55 5.56 159.55s-22.66 20.56-51.97 29.4c-21.63 6.52-59.64-7.51-59.64-7.51s-15.41-64.63-11.17-87.69c4.26-23.06 7.69-95.17 6.39-131.37-1.24-34.77 4.79-101.93 1.79-126.7-3.09-25.55 4.42-157.97-.28-191.67-6.09-43.59-20.86-103.76-20.86-103.76l32.14-84.09 150.69 22.12v-.02Z"
        style={{
          fill: '#0077be',
        }}
      />
      <path
        d="M1675.45 414.12s48.99 4.35 68.57 36.15c18.91 30.68 60.14 219.23 56.59 254.17-3.57 34.94-28.76 36.68-55.31 26.06-32.9-13.16-39.51-31.69-52.34-72.34-12.84-40.66-11.43-101.47-11.43-101.47l-6.05-142.56-.02-.02Z"
        style={{
          fill: '#e7474c',
        }}
      />
      <path
        d="M1478.86 896.98s11.81 27.96 13.21 35.64c1.4 7.69.25 25.6.73 32.99.48 7.39.78 21.27.78 21.27s-10.49-.07-13.42-7.42c-2.93-7.33-1.92-31.11-4.39-31.05s-.05 25.92 1.67 33.59c1.7 7.67 10.46 12.73 13.35 17.6 2.88 4.86 2.68 9.82 2.68 9.82l-24.4-1.01s-16.87-9.5-24.34-13.03c-7.47-3.53-12.84-8.97-16.05-14.15-2.17-3.5-4.63-28.28-4.63-28.28l7.9-66.56s10.9.83 22.62.59c11.72-.25 24.31 10.03 24.31 10.03h-.02Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1419.22 465.86c-22.18 26.35-29.81 227.41-26.58 256.12l9.14 81.36c5.82 51.72 15.54 106 15.54 106s17.35 5.81 32.49-.94c17.65-7.87 40.02-14.45 40.02-14.45s-15.7-152.31-10.19-187.18c6.14-38.96 14.61-69.94 11.84-68.68l-49.18-161.66-23.1-10.56h.02Z"
        style={{
          fill: '#e7474c',
        }}
      />
      <path
        d="M1636.69 801.03c.36-1.62-8.31 209.32-18.95 301.47-9.04 78.21-28.91 95.86-31.16 110.76-2.25 14.91-9.11 182.97-16.51 217.4-7.42 34.41-15.62 91.48-15.62 91.48s-39.33 4.39-59.91 5.72c-20.58 1.35-40.89-7.6-40.89-7.6s-2.82-98.88 6.34-165.05c9.16-66.17 19.62-124.23 21.09-145.72 1.49-21.47-2.72-36.63-4.72-67.56-2.01-30.91-10.81-145.63-7.63-197s23.15-153.34 23.15-153.34l144.81 9.43v.02Z"
        style={{
          fill: '#0077be',
        }}
      />
      <path
        d="M1537.06 391.56c-7.1 4.21-15.87 20.99-15.87 20.99s-36.26 11.35-61.29 24.08c-16.28 8.29-35.21 19.12-41.53 28.98-18.41 28.73 40.8 206.02 43.61 256.88 2.81 50.87-5.81 223.49-5.81 223.49s43.75 23.61 116.44 8.31c80.43-16.94 100.58-4.63 128.67-16.09 28.09-11.45 74.4-28.14 74.4-28.14s-36.79-153.67-38.19-207.08c-1.4-53.41 1.42-189.31 7.03-210.93 5.61-21.63 3.14-48.7-26.33-63.97-29.49-15.25-75.62-25.16-75.62-25.16s-6.02-11.95-10.19-15.2c-8.86-6.89-73.97-8.77-95.29 3.85h-.02Z"
        style={{
          fill: '#e7474c',
        }}
      />
      <g
        style={{
          clipPath: 'url(#cashier-end-b)',
        }}
      >
        <path
          d="M1520.03 387.03s-1.38 30.93 12.98 49.84c15.46 20.35 41.46 39.75 41.46 39.75l28.21-24.5 25.73 16.39c1.86 2.08 11.13-23.7 13.65-41.87 2.11-15.16-2.38-39.61-2.38-39.61s2.04-39.79.71-40.2-123.47 1.63-123.47 1.63l3.11 38.58v-.02Z"
          style={{
            fill: '#ca332e',
          }}
        />
      </g>
      <path
        d="M1625.02 652.81c2.36.16 3.62 1.9 3.66 3.02.07 1.6.07 4.69-3.91 4.42-2.52-.16-3.87-1.6-3.87-4.05 0-1.72 1.67-3.55 4.12-3.39ZM1613.39 559.65c2.36.16 3.94 1.88 3.69 4.23.07-.78.96 3.21-3.94 3.21-2.52 0-3.85-1.63-3.85-4.08 0-1.72 1.65-3.52 4.08-3.36h.02ZM1603.06 475.97c2.36.16 3.94 1.88 3.69 4.23.07-.78.96 3.21-3.94 3.21-2.52 0-3.85-1.63-3.85-4.08 0-1.72 1.65-3.52 4.08-3.36h.02ZM1631.64 721.17c2.36.16 3.94 1.88 3.69 4.23.07-.78.96 3.21-3.94 3.21-2.52 0-3.85-1.63-3.85-4.08 0-1.72 1.65-3.52 4.08-3.36h.02ZM1636.88 799.84c2.36.16 3.94 1.88 3.69 4.23.07-.78.96 3.21-3.94 3.21-2.52 0-3.85-1.63-3.85-4.08 0-1.72 1.65-3.52 4.08-3.36h.02Z"
        style={{
          fill: '#940c3b',
        }}
      />
      <path
        d="M1533.51 315.17s7.6 44.85 7 65.66c-.6 20.81-5.72 16-3.85 21.8 9.16 28.43 66.03 46.23 66.03 46.23.51-.05 38.87-29.6 26.46-46.31-2.38-3.21-4.08-10.09-2.82-26.44 1.31-17.13-4.37-39.22-4.37-39.22l-88.46-21.73h.02Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1591.52 234.32c-14.56-2.11-27.89-8.49-37.43 4.39-9.53 12.85-1.31 34.02-5.11 41.41-3.8 7.39-14.88 5.74-14.88 5.74s-6.96 7.47-5.17 19.19c1.79 11.74-2.82 47.76 2.98 57.74 5.81 9.98 20.92 24.41 30.01 32.92s34.94 8.19 43.94 1.6c8.98-6.59 26.93-25.09 30.68-31.78 3.73-6.69 7.92-41.35 9.93-52.41 2.01-11.04 1.21-26.21 1.21-26.21s-12.18-5.26-12.22-21.06c-.02-9.45-.02-25.48-9.02-32.6-20.83-16.42-24.8 2.54-34.91 1.08h-.02Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1611.06 280.46s17.86 2.27 24.96 6.48c2.49 1.47 7.26 7.76 7.26 7.76l-4.03 2.1s-3.55-3.39-7.62-4.83c-5.68-2.01-22.69-3.43-22.69-3.43l2.11-8.08ZM1581.89 277.16l1.21 8.1s-20.08-1.07-25.43.55c-5.27 1.6-10.51 4.95-10.51 4.95l-2.25-2.88s4.88-6.57 9.53-8.7c4.65-2.13 27.45-2.02 27.45-2.02Z"
        style={{
          fill: '#93a090',
        }}
      />
      <path
        d="M1569.77 365.03c3.02 4.21 13.25 9.87 21.91 8.17 9.46-1.85 16.51-8.43 17.2-10.83s-3-4.15-6.04-6.27c-3.04-2.1-6.37-2.77-8.88-1.76s-2.27 2.45-3.92 2.93-3.8-2.98-7.71-2.4-5.13 1.63-8.59 2.7c-1.92.59-6.69 3.69-3.99 7.46h.02Z"
        style={{
          fill: '#cda67b',
        }}
      />
      <path
        d="M1565.17 296.53c-3.28-1.23-6.43.11-7.51 3.37s.51 5.36 3.39 6.64c3.39 1.53 6.16.16 7.62-3.07 1.03-2.29-.12-5.68-3.5-6.96v.02Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1554.64 300.54 20.56-2.16 1.28-6.86-22.16 3.32.32 5.7zM1618.13 296.78c3.5-.07 6.02 2.24 5.97 5.66-.05 3.44-2.25 4.88-5.4 5.15-3.71.32-5.88-1.88-6.18-5.43-.21-2.5 1.99-5.33 5.61-5.4v.02Z"
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1631.7 299.26-18.35-.58-1.02-6.04 19.28 1.39.09 5.23z"
      />
      <path
        d="M1530.44 300.9s-12.11-4.56-11.52 5.81c.59 10.39 4.05 30.88 9.75 29.69s9.52-6.87 9.52-6.87l-7.74-28.64v.02ZM1637.89 340.83s4.92 5.43 8.63-1.95c3.71-7.37 10.97-29.05 7.28-30.91-3.69-1.86-10.92 1.74-10.92 1.74l-4.99 31.11v.02Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1651.46 532.69s-18.59 17.42-31.3 34.14c-19.07 25.07-16.16 40.73-16.16 40.73s22.53 28.96 42.51 47.02c19.96 18.06 115.57 75.53 115.57 75.53s41.55-16.89 27.18-49.09c-10.62-23.81-34.92-84.18-79.63-110.92-42.75-25.59-58.18-37.41-58.18-37.41h.02Z"
        style={{
          fill: '#e7474c',
        }}
      />
      <path
        d="M1651.58 544.98c-1.99-6.55-36.52-72.14-38.39-75.32-1.86-3.18-36.45-37.06-36.45-37.06s-5.56 4.1-5.18 8.22 6.41 12.68 6.41 12.68l-13.09-9.32s-5.38 5.91-1.07 11.97 21.08 18.48 22.62 20.79 2.17 3.53 2.17 3.53l-32.07-16.14s-3.21 8.49-.16 11.63c3.05 3.14 25.5 15.61 27.04 16.85 4.56 3.69 4.71 10.23 4.42 11.42-.28 1.19-3.43-4.21-8.42-7.23-4.99-3.02-20.63-10.67-20.63-10.67s-5.06 5.75-.89 11.33c2.5 3.36 14.58 8.82 16.8 10.71s16.03 19.58 17.9 23.37c1.86 3.78 7.71 28.99 21.4 41.17 5.47 4.86 18.61 24.66 19.73 22.85 6.96-11.15 24.47-28.91 17.84-50.78h.02Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        style={{
          fill: '#0077be',
        }}
        d="m1614.33 966.85 24.7-104.56 26.06 100.03-50.76 4.53z"
      />
      <path
        d="m1487.77 541.87 2.7 38.1 83.57-9.3-4.03-36.22c-1.12-.11-82.24 7.4-82.24 7.4v.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <g
        style={{
          clipPath: 'url(#cashier-end-c)',
        }}
      >
        <path
          style={{
            fill: '#4a9055',
          }}
          d="m1471.61 552.46 107.03-8.92-4.22-27.7-99.52 11.74-3.29 24.88z"
        />
      </g>
      <path
        d="M1648.32 280.3s-12.14 73.33-18.48 77.06c-10.74 6.32-13.44-7.14-23.33-9.11-10.24-2.04-13.41 1.85-16.09 1.74-2.68-.12-8.29-3.14-16.03-1.44-5.5 1.21-18.06 10.53-27.11 9.11-11.38-1.78-9.46-20.53-10.3-24.36-4.69-21.66-3.02-53.2-3.02-53.2l-5.49 2.02s-1.83 65.22 1.72 76.45c3.55 11.24 8.52 23.47 16.57 30.57 8.06 7.1 12.77 15.16 19.12 16.76 9.18 2.33 32.42 3.82 40.36-.78s27.08-28.75 30.15-33.75 7.33-43.45 8.59-48.53c3.66-14.9 6.71-38.21 6.71-38.21l-3.37-4.35Zm-53.87 104.76c-10.26.99-20.72.27-26.81-3.27-2.17-1.26-8.19-6.02-8.95-11.35s11.19-16.73 19.62-17.12c7.63-.34 7.26.99 10.9 1.31 3.73.32 8.04-4.6 15.36-1.86 6.2 2.33 15.77 13.14 14.35 17.58-2.17 6.78-18.06 14.08-24.45 14.7h-.02Z"
        style={{
          fill: '#93a090',
        }}
      />
    </svg>
  )
}

export default CashierEnd
